import { StatsigClient } from '@statsig/js-client';
import { dispatch } from '@/figma/ui-message-handler';
import { FF_COPY_TO_AI_ASSISTANT } from './flags';

export const STATSIG_ANONYMOUS = { userID: null, email: null };
export * from './flags';

export const statsig = new StatsigClient(import.meta.env.VITE_STATSIG_KEY, STATSIG_ANONYMOUS, {
  environment: { tier: import.meta.env.MODE },
});

export const initialize = () => {
  statsig.initializeSync();

  statsig.on('values_updated', () => {
    dispatch('getFeatureFlags', getFeatureFlags());
  });
};

export const hasFeatureFlag = (featureFlag) => {
  return statsig.checkGate(featureFlag);
};

export const getFeatureFlags = () => {
  return {
    [FF_COPY_TO_AI_ASSISTANT]: hasFeatureFlag(FF_COPY_TO_AI_ASSISTANT),
  };
};
